var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-btn',{attrs:{"small":"","color":_vm.color,"rounded":!_vm.fab,"fab":_vm.fab,"elevation":"0"},on:{"click":_vm.handlePlus}},[_c('lynus-icon',{attrs:{"name":_vm.icon,"size":"24","color":"white"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }